import { Text, View, Image, TouchableOpacity } from 'react-native';
import React, { FC, useMemo, useState } from 'react';
import { CollapseProps } from './Collapse.types';
import { collapseStyled } from './Collapse.styled';
import { STYLE_VARS } from '../../constants/style-vars';
// import { useIsDesktop } from '../../hooks/useIsDeskTop';

const Collapse: FC<CollapseProps> = ({ section }) => {
  // const isDesktop = useIsDesktop();
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const renderHeaderCollapse = useMemo(() => {
    return (
      <TouchableOpacity
        key={section.title}
        onPress={() => {
          setCollapsed(!collapsed);
        }}
        style={{ marginBottom: 20 }}
      >
        <View
          style={[
            collapseStyled.header,
            collapsed == true && {
              backgroundColor: STYLE_VARS.fccLightGrey,
              borderColor: STYLE_VARS.fccLightGrey,
            },
          ]}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <View style={collapseStyled.headerLine} />
            <Text style={collapseStyled.headerTitle}> {section.title} </Text>
            <View style={collapseStyled.headerLine} />
          </View>
          <Image
            source={
              collapsed == true
                ? require('../../assets/up-button.png')
                : require('../../assets/down-button.png')
            }
            style={{
              width: 15,
              height: 8,
            }}
          />
        </View>
      </TouchableOpacity>
    );
  }, [collapsed, section.title]);

  const renderSections = useMemo(() => {
    if (collapsed === true) {
      return <View key={section.content?.toString()}>{section.content}</View>;
    } else {
      return <></>;
    }
  }, [section.content, collapsed]);

  return (
    <View>
      {renderHeaderCollapse}
      {renderSections}
    </View>
  );
};

export default Collapse;
